import { createRoute, redirect } from '@tanstack/react-router'
import { rootRoute } from './__root'
import { hasAnyAuthToken } from 'shared/lib/auth'

export const authRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/auth',
  beforeLoad: () => {
    if (hasAnyAuthToken()) {
      throw redirect({ to: '/floor-6/map/$block', params: { block: 'full' } })
    }
  },
}).lazy(() => import('./auth.lazy').then((d) => d.authLazyRoute))
